import { render, staticRenderFns } from "./send_email.vue?vue&type=template&id=7f879491&scoped=true&"
import script from "./send_email.vue?vue&type=script&lang=js&"
export * from "./send_email.vue?vue&type=script&lang=js&"
import style0 from "./send_email.vue?vue&type=style&index=0&id=7f879491&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f879491",
  null
  
)

export default component.exports